module.exports = __webpack_public_path__ + "images/assets/dc0e3c3a94953e7ee1f9b56b00697086.svg";